import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { ApiConfig } from "./apiConfig";
import { LoaderProvider } from "./context/LoaderContext";
import { bootstrapSession } from "./auth/bootstrap";

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// (Optional) tiny splash while config is loading
function Splash() {
  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        height: "100vh",
        fontFamily: "system-ui",
      }}
    >
      <div>Loading…</div>
    </div>
  );
}
root.render(<Splash />);

async function bootstrap() {
  try {
    // Load configuration dynamically
    await ApiConfig.getInstance().load(); // Initializes API config from config.json or .env

    // Dynamically update favicon based on the environment's WordPress URL
    try {
      const wordpressUrl = ApiConfig.getInstance().wordpressUrl;
      const faviconUrl = `${wordpressUrl}/wp-content/uploads/2026/06/TickTech_RGB_ICON.png`;
      const linkTags = document.querySelectorAll("link[rel*='icon']");
      linkTags.forEach((tag) => {
        tag.setAttribute("href", faviconUrl);
      });
    } catch (e) {
      console.warn("Could not dynamically update favicon:", e);
    }

    await bootstrapSession();
    // Dynamically import App AFTER config is available
    const { default: App } = await import("./App");

    // Now render the real app
    root.render(
      <Provider store={store}>
        <BrowserRouter
          basename={process.env.PUBLIC_URL}
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <LoaderProvider>
            <App />
          </LoaderProvider>
        </BrowserRouter>
      </Provider>,
    );
  } catch (error) {
    console.error("Failed to load configuration:", error);
    root.render(
      <div
        style={{
          display: "grid",
          placeItems: "center",
          height: "100vh",
          fontFamily: "system-ui",
        }}
      >
        <div>
          <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
            App failed to start
          </div>
          <div>
            Couldn’t load configuration. Check the network tab and file
            location.
          </div>
        </div>
      </div>,
    );
  }
}

bootstrap();
reportWebVitals();
